import languages from '../utils/language/languages';
import languageMapping from '../utils/language/languageMapping';
import * as I18n from '../types/i18n';

type UseLanguageOptions =
  | {
      mapping?: 'i18n' | 'template';
    }
  | undefined;
/** Checks if the languageId supplied matches a key on the languages object. */
const isLanguage = (languageId: string): languageId is I18n.AvailableLanguagesKey => {
  return languageId in languages;
};

/**
 *
 * @param languageId
 * @param options `UseLanguageOptions`
 * @returns `I18n.Language`
 */
const useLanguage = (languageId: string, options: UseLanguageOptions = {}) => {
  let mappingKey = {};

  if (isLanguage(languageId)) {
    if (options.mapping) {
      if (options.mapping === 'i18n') {
        mappingKey = {
          i18nKey: languageMapping.i18n.get(languageId),
        };
      }

      if (options.mapping === 'template') {
        const currentMappedKey = languageMapping.i18n.get(languageId);
        if (currentMappedKey) {
          mappingKey = {
            langPrefix: languageMapping.template.get(currentMappedKey),
          };
        }
      }
    }

    return {
      ...languages[languageId],
      mappingKey,
    };
  }

  return languages.en;
};

export default useLanguage;
